import axios from "axios";

// Production deploys serve frontend + backend from the same host (Emergent's
// Kubernetes ingress routes /api → backend on 8001, / → frontend on 3000).
// Using a relative baseURL avoids all cross-origin cookie / CORS weirdness on
// custom domains (ekkol.app) and preview alike. The REACT_APP_BACKEND_URL env
// var is kept exported for any code that needs the absolute origin, but
// api calls always use same-origin.
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || (typeof window !== "undefined" ? window.location.origin : "");
export const API = "/api";

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach token fallback (in case cookies are blocked)
api.interceptors.request.use((config) => {
  // Support both new "ekkol_token" and legacy "echostudy_token" so existing sessions don't break
  const token = localStorage.getItem("ekkol_token") || localStorage.getItem("echostudy_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
